module.exports = __webpack_public_path__ + "static/media/CHANGELOG.800376b7.md";


//////////////////
// WEBPACK FOOTER
// ./src/CHANGELOG.md
// module id = 1131
// module chunks = 0